module.exports = __webpack_public_path__ + "img/valor.e0f4e001.svg";